<template>
  <div v-if="user" class="flex flex-row gap-2 w-full pb-1">
    <UserImage :imageId="user.profileImageId" class="mt-[7px] flex-none"/>
    <div class="flex flex-col gap-1 w-full">
      <textarea
          :disabled="uploadingComment"
          type="text"
          :placeholder="$t('spotdetail.comments_add_placeholder')"
          class="border-solid border-theme-primary border-[1px] p-1 bg-theme-bg focus:border-theme-secondary focus:border-[2px] focus:p-[9px] focus:bg-white min-h-[6em]"
          v-model="text"
      ></textarea>
      <i18n-t
          keypath="spotdetail.comments_guidelines_text"
          scope="global"
          tag="p"
          class="text-sm italic"
      >
        <template v-slot:guidelines
        ><a href="/guidelines" class="underline">{{
            $t("spotdetail.comments_guidelines_link_title")
          }}</a></template
        >
      </i18n-t
      >
      <div class="flex justify-end gap-1">
        <ButtonPrimary
            v-if="allowCancel"
            @click="emits('dismiss')"
        >{{ $t('general.cancel') }}
        </ButtonPrimary>
        <ButtonSubmit
            @click="addComment()"
            :disableSubmit="text.length < 3"
            :loading="uploadingComment"
            :error="error"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

const props = defineProps<{
  user?: User,
  spot: SpotDetail,
  comment?: Comment
  allowCancel?: boolean
}>()

const emits = defineEmits(["submit", "dismiss"]);

const uploadingComment = ref(false);
const error = ref(false);
const text = ref("");

function addComment() {
  uploadingComment.value = true;

  const formData = new FormData();
  formData.append("text", text.value);

  let url = 'spots/' + props.spot.id.toString() + '/comment';
  if (props.comment) {
    url =
        "spots/" +
        props.spot.id.toString() +
        "/comments/" +
        props.comment.id.toString() +
        "/reply";
    formData.append("parentId", props.comment.id.toString());
  }


  useApiAuth().post<Comment>(url, formData)
      .then(function (response) {
        uploadingComment.value = false;
        error.value = false;
        emits("submit");
        if (props.comment) {
          props.comment.replies.push(response);
        } else {
          props.spot.comments.unshift(response);
        }
        props.spot.userData.follows = true;
        text.value = "";
      })
      .catch(function (error) {
        uploadingComment.value = false;
        error.value = true;
        console.log(error);
      });
}
</script>
